module.exports = __webpack_public_path__ + "static/media/14.01f8b812.png";